import { Box, Button } from "@mui/material";
import { useFormik } from "formik";
import { object, string } from "yup";
import { BasicFormikForm } from "../../form/BasicFormikForm";
import { RequestHelper } from "../../../utils/requestHelper";
import { _ACTIONS, _HTTP } from "../../../utils/constants";
import { _ROUTES } from "../../../utils/_routes_constants";
import { createToast } from "../../../utils/toast";

const requestHelper = new RequestHelper();

export default function FormVolumeFilaire({
  setRows,
  rowData = null,
  isEdit = false,
}) {
  const v = object({
    name: string().required().label("Name"),
  });

  const formik = useFormik({
    initialValues: {
      name: isEdit ? rowData?.name : "",
    },
    validationSchema: v,
    onSubmit: (values) => {
      const url = isEdit
        ? _ROUTES.VOLUME_FILAIRE + "/" + rowData.id
        : _ROUTES.VOLUME_FILAIRE;
      const httpMethod = isEdit ? _ACTIONS.PATCH : _ACTIONS.POST;

      requestHelper
        .doRequest(httpMethod, url, values)
        .then((res) => {
          if ([_HTTP.ok, _HTTP.created].includes(res.status)) {
            const successSentence = isEdit ? " updated " : " created ";
            createToast(
              "success",
              "Volume filaire" + successSentence + "successfully",
            );

            setRows((prev) => {
              if (isEdit) {
                return prev.map((r) => {
                  if (r.id === rowData.id) {
                    return res.data;
                  }
                  return r;
                });
              } else {
                return [...prev, res.data];
              }
            });
          }
        })
        .catch((err) => {
          createToast(
            "error",
            "An error occurred while creating the volume filaire",
          );
        });
    },
  });

  return (
    <form onSubmit={formik.handleSubmit}>
      <BasicFormikForm formik={formik} validations={v} />
      <Box sx={{ w: "100%", display: "flex", justifyContent: "center", mt: 2 }}>
        <Button type="submit" variant="contained" color="success">
          Save
        </Button>
      </Box>
    </form>
  );
}
